'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.627 10.178 19.014 5.95l-.007-3.56a1.175 1.175 0 0 0-1.18-1.107l-.796-.01a1.136 1.136 0 0 0-1.169 1.139l-.007.642L13.064.495l-.178-.163a1.246 1.246 0 0 0-.44-.257l-.02-.006a1.335 1.335 0 0 0-.2-.05C12.2.014 12.172.013 12.144.01a.967.967 0 0 0-.286 0c-.028.002-.056.003-.084.008a1.338 1.338 0 0 0-.2.05c-.006.003-.013.004-.02.006a1.246 1.246 0 0 0-.439.257l-.178.163L.373 10.178A1.136 1.136 0 0 0 .32 11.81l.27.28a1.175 1.175 0 0 0 1.612.124l.803-.719V22.02a1.167 1.167 0 0 0 1.168 1.167h15.654a1.167 1.167 0 0 0 1.168-1.167V11.495l.803.719c.485.394 1.193.339 1.612-.124l.27-.28a1.136 1.136 0 0 0-.053-1.632Zm-13.097 7.07H5.823v-4.6h4.707v4.6Zm7.578 0h-4.706v-4.6h4.706v4.6Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
});
var House = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.House = House;